export default __webpack_public_path__ + "static/pillar-5190e2a731c22a5b5b00f49563667558.svg";